/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type SerieTransportType = typeof SerieTransportType[keyof typeof SerieTransportType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SerieTransportType = {
  Flight: 'Flight',
  Bus: 'Bus',
  Combined: 'Combined',
} as const;
